import { Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import Pills from '/@/components/pills';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import CardContainer from '/@/views/catalog/product-selection/product/assets/card-container.svg';
import Alert from '../../bayer/alert';
import styles from '../styles.module.css';

const ApplyAlert = ({ state, product }) => {
    if (state === 'present') {
        return (
            <Alert severity='surfaceVariant'>
                {_('¡Tus cultivos están listos para utilizar {{product}}!', { product })}
            </Alert>
        );
    }
    if (state === 'past') {
        return (
            <Alert severity='danger'>{_('Ya no se puede utilizar {{product}} en tus cultivos.', { product })}</Alert>
        );
    }
    if (state === 'future') {
        return (
            <Alert severity='danger'>
                {_('Tus cultivos aún no se encuentran preparados para utilizar {{product}}.', { product })}
            </Alert>
        );
    }
};

const ModalTechnology = (props) => {
    return (
        <Grid container direction='column' spacing={2}>
            <Grid item>
                {props.card ? (
                    <Box
                        sx={{
                            mt: '-9px',
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundImage: `url(${CardContainer})`,
                            height: '75px',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            position: 'relative',
                            top: '-15px',
                        }}
                    >
                        <img src={`${props.image}`} alt={props.name} width='80px' height='75px' loading='lazy' />
                    </Box>
                ) : (
                    <img src={`${props.image}`} alt={props.name} width='80px' height='75px' loading='lazy' />
                )}
            </Grid>
            <Grid item>
                <Pills maxWidth={props.card} type={props.pills.type} crops={props.pills.crops} />
            </Grid>
            <Grid item>
                <ApplyAlert state={props.state} product={props.name} />
            </Grid>
            {props.description && (
                <Grid item>
                    <Title className={styles.textModalProductApply} color='dark'>
                        {_(props.description)}
                    </Title>
                </Grid>
            )}

            <Grid item>
                <Button onClick={props.click} size={props.card ? 'small' : 'medium'} variant='contained'>
                    {_(props.btnText)}
                </Button>
            </Grid>
        </Grid>
    );
};

ModalTechnology.propTypes = {
    image: PropTypes.string,
    pills: PropTypes.object,
    name: PropTypes.string,
    description: PropTypes.string,
    btnText: PropTypes.string,
    apply: PropTypes.bool,
    click: PropTypes.func,
};

export default ModalTechnology;
